module.exports = __webpack_public_path__ + "static/img/addService@2x.b9455bea.png";